import React, { useEffect, useState, useMemo } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'

import ChartDataLabels from 'chartjs-plugin-datalabels'
import { useToasts } from 'react-toast-notifications'
import { Bar } from 'react-chartjs-2'

import { useSelector } from 'react-redux'

import axiosInstance from '../../../../../services/config/AxiosIntance'

import Loader from '../../../../../components/Loader'
import DashboardItemTitle from '../../components/DashboardItemTitle'
import NoData from '../../components/NoData'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const NewApplicantChart = () => {
  const filters = useSelector((state) => state.dashboard.filters)
  const { addToast } = useToasts()

  const [loading, setLoading] = useState(false)
  const [totalApplicants, setTotalApplicants] = useState(0)
  const [chartData, setChartData] = useState({
    labels: [''],
    datasets: [],
  })

  useEffect(() => {
    setLoading(true)
    const queryParams = new URLSearchParams(filters).toString()

    axiosInstance
      .get(`/dashboard/new-applicants?${queryParams}`)
      .then((res) => {
        const chartColors = ['#1977f2', '#ffcd4e']

        setChartData((prev) => ({
          ...prev,
          labels: res.data.result.labels,
          datasets: res?.data?.result?.datasets.map((item, index) => ({
            label: item.name,
            data: item.data,
            backgroundColor: chartColors[index],
            borderColor: chartColors[index],
            borderWidth: 1,
            barPercentage: 1,
          })),
        }))
        setTotalApplicants(res.data.result.total_applicants)
      })
      .catch((err) => {
        addToast(
          err?.response?.message ||
          err?.response?.data?.message ||
          'Internal Server Error',
          {
            appearance: 'error',
            autoDismiss: true,
          }
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }, [filters])

  const options = useMemo(
    () => ({
      type: 'bar',
      data: chartData,
      maintainAspectRatio: false,
      plugins: {
        title: {
          color: 'black',
          display: true,
          align: 'start',
          position: 'top',
          text: `New Applicants: ${totalApplicants}`,
          font: {
            size: 24,
            family: "'Lato', 'sans-serif'",
            weight: 300,
          },
        },
        datalabels: {
          formatter: (value) => (value === 0 ? '' : value),
          display: (ctx) => Boolean(ctx.dataset.data !== 0),
          color: 'black',
          anchor: 'center',
          clamp: true,
        },
      },
      scales: {
        x: {
          stacked: true,
          grid: {
            display: false,
          },
        },
        y: {
          stacked: true,
          grid: {
            display: false,
          },
          ticks: {
            padding: 0.5,
          },
        },
      },
      responsive: true,
    }),
    [totalApplicants]
  )

  const component = loading ? (
    <Loader />
  ) : chartData.labels.length ? (
    <Bar options={options} data={chartData} plugins={[ChartDataLabels]} />
  ) : (
    <>
      <DashboardItemTitle title="New Applicants" />
      <NoData />
    </>
  )

  return component
}

export default NewApplicantChart
